document.addEventListener("DOMContentLoaded", function () {
  //add  mobile cond here
  if (window.innerWidth <= 768) {
    const parent = document.querySelectorAll(".product-item__main");
    if (parent.length > 1) {
      for (let ip = 0; ip < parent.length; ip++) {
        const childrenparent = parent[ip].querySelector(".product-form__input");
        if (childrenparent) {
          const children = Array.from(
            childrenparent.querySelectorAll(".selecotr-item")
          );
          let optionslength = 7;
          let classnameAdd = "show-overflow";
          labeltext = children[0].querySelector(".selector-item_label");
          text_length = labeltext.textContent.trim().length;

          if (text_length > 3) {
            optionslength = 3;
            classnameAdd = "show-overflow-large";
          }
          
          //console.log(text_length + '~'+children.length+ '~' + optionslength);
          if (children.length > optionslength) {
            childrenparent.querySelector(
              ".product-size-item",
              ".more"
            ).style.display = "block";
            childrenparent.classList.add(classnameAdd);
            //break;
          }
        }
      }
    }
  }
});
